module.exports = __webpack_public_path__ + "images/trigger-offer-bg-mobile.jpg";